import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../../symbols/HTHSymbol";
import {HTHAvalancheReelModel} from "../../reels/HTHAvalancheReelModel";
import {HTHScatterSymbol} from "../../symbols/HTHScatterSymbol";
import {HTHSafeSymbol} from "../../symbols/HTHSafeSymbol";
import {HTHGameConfig} from "../../HTHGameConfig";
import {HTHSound} from "../../sound/HTHSound";

export class CollapsePresentation implements SimplePresentation {
    name: string = "CollapsePresentation";

    shouldRun(): boolean {
        return HTH.model.isNextAvalanche && !HTH.model.brokeTheBank && !HTH.model.isGodModeMaxWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const collapseTl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.screenInteractive.setInteractiveState(false);
                controller.setSkipCallback();
                controller.finish()
            }
        });
        if (HTH.model.gameData?.betWayWins.length === 0) {
            HTH.screenInteractive.setInteractiveState(true);
            if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
               // console.log("already at 1st skip xsplitpresentation");
                collapseTl.timeScale(2);
            } else if (HTHGameConfig.isSkipped[1]) {
               // console.log("already at 2nd skip collapsepresentation");
                collapseTl.timeScale(4);
                HTH.screenInteractive.setInteractiveState(false);
            }
        }

        HTH.screenInteractive.clickArea.on('pointerdown', () => {
            if (!HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
              //  console.log("1st skip xsplitpresentation");
                HTHGameConfig.isSkipped[0] = true;
                collapseTl.timeScale(2);
            } else if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
              //  console.log("2nd skip collapsepresentation");
                HTHGameConfig.isSkipped[1] = true;
                collapseTl.timeScale(4);
                HTH.screenInteractive.setInteractiveState(false);
            }
        });

        controller.setSkipCallback();

        collapseTl.add(HTH.reelArea.collapse(), 0);

        HTH.reelArea.allReels.forEach((reel: HTHAvalancheReelModel, reelID: number) => {
            collapseTl.add(reel.reelView.avasplitEffect(), 0);
        });
        collapseTl.add(() => {
            HTHSound.playTrack(HTHSound.AVASPLIT);
        }, 0);
        HTH.reelArea.allReels.forEach((reel) => {
            reel.reelView.getAllSymbols().forEach((sym: HTHSymbol) => {
                if (sym.symName === "SC" || sym.symName === "SA") {
                    if ((<HTHScatterSymbol | HTHSafeSymbol>sym).isAnticipationPlaying) {
                        (<HTHScatterSymbol | HTHSafeSymbol>sym).isAnticipationPlaying = false;
                    }
                }
            })
        })


    }
}